import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

/**
 * Reusable FAQ section. Schema injection should be done separately in the
 * page via Seo({ schema: faqSchema(faqs) }).
 */
export const FaqAccordion = ({
  eyebrow = "FAQ",
  heading,
  subheading,
  faqs = [],
  background = "white",
  idPrefix = "faq",
}) => {
  const bgClass = background === "slate" ? "bg-slate-50" : "bg-white";

  return (
    <section className={`py-20 md:py-28 ${bgClass}`} data-testid="faq-section">
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="text-teal font-semibold text-sm uppercase tracking-wider">
            {eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-navy mt-3 mb-4">
            {heading}
          </h2>
          {subheading && (
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              {subheading}
            </p>
          )}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion
            type="single"
            collapsible
            className="space-y-3"
            data-testid="faq-accordion"
          >
            {faqs.map((faq, i) => (
              <AccordionItem
                key={`${idPrefix}-${i}`}
                value={`${idPrefix}-${i}`}
                className={`${
                  background === "slate" ? "bg-white" : "bg-slate-50"
                } rounded-xl px-6 border-none`}
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-semibold text-navy hover:text-teal hover:no-underline py-5 text-base">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
